import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/footer-directory-badges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/site-header.tsx");
